import { create } from 'zustand'

interface DoubleChanceStore {
    isDoubleChanceActivated: boolean
    setIsDoubleChanceActivated: (isDoubleChanceActivated: boolean) => void
}

export const useDoubleChanceStore = create<DoubleChanceStore>((set) => ({
    isDoubleChanceActivated: false,
    setIsDoubleChanceActivated: (isDoubleChanceActivated) => {
        set({ isDoubleChanceActivated })
    },
}))
